<template>
  <span class="loading-inline">
    <div
      class="loading"
      :class="{ 'danger-loader': colorClass === 'danger',
                'success-loader': colorClass === 'success',
                'warning-loader': colorClass === 'warning' }"></div>
  </span>
</template>

<script>
export default {
  name: 'loader-inline',

  props: {
    colorClass: { type: String, default: '' },
  },
};
</script>

<style lang="scss" scoped>
  @import "~assets/css/colors";

  .loading-inline {
    display: inline-block;
    position: relative;
    height: 1.2em;
    width: 1.6em;
    vertical-align: middle;
  }

  .danger-loader::after {
    border-top-color: $dangercolor;
  }
  .success-loader::after {
    border-top-color: $successcolor;
  }
  .warning-loader::after {
    border-top-color: $warningcolor;
  }
</style>
